import { Button } from "@/components/ui/button";
import { MoreVertical, Archive, ArchiveRestore } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface EventActionsProps {
  archived: boolean;
  onArchiveToggle?: () => void;
}

export const EventActions = ({ archived, onArchiveToggle }: EventActionsProps) => {
  if (!onArchiveToggle) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="dropdown-menu">
          <MoreVertical className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={onArchiveToggle}>
          {archived ? (
            <>
              <ArchiveRestore className="w-4 h-4 mr-2" />
              Restore
            </>
          ) : (
            <>
              <Archive className="w-4 h-4 mr-2" />
              Archive
            </>
          )}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};